// import {
//   createContext,
//   useContext,
//   useState,
//   useEffect,
//   useCallback,
// } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { baseUrl } from "../utils/OtherUtils";
// import Cookies from "js-cookie";

// const AuthContext = createContext();

// const AuthProvider = ({ children }) => {
//   const navigate = useNavigate();
//   const [isAuth, setIsAuth] = useState(false);
//   const [isTCPP, setIsTCPP] = useState(false);
//   const [isTC, setIsTC] = useState(false);
//   const [userLocation, setUserLocation] = useState({
//     latitude: "",
//     longitude: "",
//   });
//   const [userLocationAddress, setUserLocationAddress] = useState("");
//   const [userRegisterData, setUserRegisterData] = useState({
//     name: "",
//     email: "",
//     contact:"",
//     password: "",
//     confirmPassword: "",
//   });
//   const [userLoginData, setUserLoginData] = useState({
//     email: "",
//     password: "",
//   });
//   const [userForgotPasswordData, setUserForgotPasswordData] = useState({
//     email: "",
//   });
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userData, setUserData] = useState({});
//   const [notificationData, setNotificationData] = useState({
//     flag: null,
//     message: "",
//   });
//   const [scrollDirection, setScrollDirection] = useState("up");
//   const [isSearchVisible, setIsSearchVisible] = useState(false);
//   const [isSidebar, setIsSidebar] = useState(false);
//   const [deviceOS, setDeviceOS] = useState("");

//   const detectDeviceOS = () => {
//     const userAgent = navigator.userAgent.toLowerCase();

//     if (/android/.test(userAgent)) {
//       setDeviceOS("android");
//     } else if (/iphone|ipad|ipod/.test(userAgent)) {
//       setDeviceOS("ios");
//     } else {
//       setDeviceOS("unknown");
//     }
//   };

//   const handleSidebarClick = () => {
//     setIsSidebar((prev) => !prev);
//   };

//   const handleNotification = (flag, message) => {
//     setNotificationData({
//       flag,
//       message,
//     });
//   };

//   const handleAuth = () => {
//     setIsAuth(false);
//   };

//   const handleTCPP = () => {
//     setIsTCPP((prev) => !prev);
//   };

//   const handleTC = () => {
//     setIsTC((prev) => !prev);
//   };

//   // Save current location
//   const saveCurrentLocation = () => {
//     // Check if the browser supports Geolocation API
//     if (!navigator.geolocation) {
//       console.error("Geolocation is not supported by your browser.");
//       handleNotification(
//         false,
//         "Geolocation is not supported by your browser."
//       );
//       return;
//     }

//     // Get the user's current position
//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//         const { latitude, longitude } = position.coords;
//         // Update the state with the location
//         setUserLocation({ latitude, longitude });
//       },
//       (err) => {
//         // Log errors to the console
//         console.error("Error getting location:", err.message);
//         handleNotification(false, err.message);
//       },
//       {
//         enableHighAccuracy: true, // Request high accuracy if available
//         timeout: 10000, // Timeout after 10 seconds
//         maximumAge: 0, // Prevent cached locations
//       }
//     );
//   };

//   useEffect(() => {
//     if (!userLocation?.latitude || !userLocation?.longitude && !(deviceOS === "android" || deviceOS === "ios")) {
//       saveCurrentLocation();
//     }
//   }, [userLocation]);

//   // Fetch user location
//   const fetchUserAddress = async () => {
//     const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${userLocation?.latitude}&lon=${userLocation?.longitude}`;

//     try {
//       const response = await fetch(url);
//       const data = await response.json();
//       if (data.display_name) {
//         setUserLocationAddress(data.display_name);
//       } else {
//         setUserLocationAddress("Address not found");
//       }
//     } catch (error) {
//       console.error("Error fetching address:", error);
//       setUserLocationAddress("Error fetching address");
//     }
//   };

//   useEffect(() => {
//     if (userLocation?.latitude && userLocation?.longitude) {
//       fetchUserAddress();
//     }
//   }, [userLocation?.latitude, userLocation?.longitude]);

//   // Handle form submission for user registration
//   const handleUserRegister = async () => {
//     const url = `${baseUrl}/auth/register`;

//     try {
//       const response = await axios.post(url, userRegisterData);

//       if (response?.data?.success) {
//         // Save token and userId to cookies
//         Cookies.set("token", response.data.token, { expires: 30 });
//         Cookies.set("userId", response?.data.userId, { expires: 30 });
//         getUser();
//         setIsLoggedIn(true);
//         setIsSidebar(false);

//         // Clear the form data
//         setUserRegisterData({
//           name: "",
//           email: "",
//           password: "",
//           confirmPassword: "",
//         });

//         setIsAuth(false);
//       }
//     } catch (error) {
//       console.error(
//         "Error during registration:",
//         error.response ? error.response.data : error.message
//       );
//     }
//   };

//   // Handle form submission for user login
//   const handleUserLogin = async () => {
//     const url = `${baseUrl}/auth/login`;

//     try {
//       const response = await axios.post(url, userLoginData);

//       //console.log("User response data : ", response?.data);
//       if (response?.data?.success) {
//         // Save token and userId to cookies
//         Cookies.set("token", response.data.token, { expires: 30 });
//         Cookies.set("userId", response?.data.userId, { expires: 30 });
//         getUser();
//         setIsLoggedIn(true);
//         setIsSidebar(false);

//         // Clear the form data
//         setUserLoginData({
//           email: "",
//           password: "",
//         });

//         setIsAuth(false);
//       }
//     } catch (error) {
//       console.error(
//         "Error during registration:",
//         error.response ? error.response.data : error.message
//       );
//     }
//   };

//   // Function to handle the forgot password request
//   const handleForgotPassword = async () => {
//     const url = `${baseUrl}/auth/forgot-password`;
//     const email = userForgotPasswordData?.email;

//     try {
//       // Make POST request to the backend with email data
//       const response = await axios.post(url, { email });

//       // Log response data for debugging

//       // Handle success
//       if (response.data.success) {
//         alert(response.data.message); // Display success message
//       } else {
//         handleNotification(false, response.data.message); // Display error message from backend
//       }
//     } catch (error) {
//       // Handle error response
//       console.error("Error during password reset request:", error);
//       handleNotification(
//         error.response.data.success,
//         error.response.data.message
//       );
//     }
//   };

//   // Memoized function to get user profile data using useCallback
//   const getUser = useCallback(async () => {
//     try {
//       const token = Cookies.get("token");
//       const userId = Cookies.get("userId");
//       const url = `${baseUrl}/auth/get-user`;

//       // Make the GET request to fetch user data
//       const response = await axios.get(url, {
//         params: {
//           userId: userId,
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (response?.data?.success) {
//         setUserData(response?.data?.user);
//       }
//     } catch (error) {
//       console.error(
//         "Error fetching user profile:",
//         error.response ? error.response.data : error.message
//       );
//     }
//   }, []);

//   const deleteUser = async () => {
//     const token = Cookies.get("token");
//     const userId = Cookies.get("userId");
//     const url = `${baseUrl}/auth/delete`;
//     try {
//       const response = await axios.delete(url,{
//         params: {
//           userId: userId,
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (response?.data?.success) {
//         handleUserLogout();
//       }
//     } catch (error) {
//       console.error(
//         "Error deleting user profile:",
//         error.response ? error.response.data : error.message
//       );
//     }
//   }

//   useEffect(() => {
//     const token = Cookies.get("token");
//     const userId = Cookies.get("userId");
//     setIsLoggedIn(!!(token && userId));

//     if (token && userId) {
//       getUser();
//     }
//   }, [navigate, getUser]);

//   // To remove the cookies during logout
//   const handleUserLogout = () => {
//     Cookies.remove("token");
//     Cookies.remove("userId");
//     localStorage.removeItem("finelabsOrder");
//     setIsLoggedIn(false);
//     navigate("/");
//   };

//   {
//     /*   useEffect(() => {
//     saveCurrentLocation();
//   }, []); */
//   }

//   useEffect(() => {
//     detectDeviceOS();
//   }, []);

//   return (
//     <AuthContext.Provider
//       value={{
//         setUserLocation,
//         handleNotification,
//         notificationData,
//         handleAuth,
//         isAuth,
//         setIsAuth,
//         isLoggedIn,
//         userRegisterData,
//         setUserRegisterData,
//         handleUserRegister,
//         userLoginData,
//         setUserLoginData,
//         handleUserLogin,
//         handleUserLogout,
//         isTCPP,
//         handleTCPP,
//         isTC,
//         handleTC,
//         userData,
//         saveCurrentLocation,
//         userLocation,
//         isSearchVisible,
//         setIsSearchVisible,
//         scrollDirection,
//         setScrollDirection,
//         isSidebar,
//         setIsSidebar,
//         handleSidebarClick,
//         userForgotPasswordData,
//         setUserForgotPasswordData,
//         handleForgotPassword,
//         deviceOS,
//         fetchUserAddress,
//         userLocationAddress,
//         deleteUser,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuthContext = () => useContext(AuthContext);

// export default AuthProvider;

import Navbar from "../components/Navbar";
import {
	createContext,
	useContext,
	useState,
	useEffect,
	useCallback,
} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../utils/OtherUtils";
import Cookies from "js-cookie";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
	const navigate = useNavigate();
	const [isAuth, setIsAuth] = useState(false);
	const [isTCPP, setIsTCPP] = useState(false);
	const [isTC, setIsTC] = useState(false);
	const [userLocation, setUserLocation] = useState({
		latitude: "",
		longitude: "",
	});
	const [userLocationAddress, setUserLocationAddress] = useState("");
	const [userRegisterData, setUserRegisterData] = useState({
		name: "",
		email: "",
		contact: "",
		password: "",
		confirmPassword: "",
	});
	const [userLoginData, setUserLoginData] = useState({
		email: "",
		password: "",
	});
	const [userForgotPasswordData, setUserForgotPasswordData] = useState({
		email: "",
	});
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [userData, setUserData] = useState({});
	const [notificationData, setNotificationData] = useState({
		flag: null,
		message: "",
	});
	const [scrollDirection, setScrollDirection] = useState("up");
	const [isSearchVisible, setIsSearchVisible] = useState(false);
	const [isSidebar, setIsSidebar] = useState(false);
	const [deviceOS, setDeviceOS] = useState("");

	const detectDeviceOS = () => {
		const userAgent = navigator.userAgent.toLowerCase();

		if (/android/.test(userAgent)) {
			setDeviceOS("android");
		} else if (/iphone|ipad|ipod/.test(userAgent)) {
			setDeviceOS("ios");
		} else {
			setDeviceOS("unknown");
		}
	};

	const handleSidebarClick = () => {
		setIsSidebar((prev) => !prev);
	};

	const handleNotification = (flag, message) => {
		setNotificationData({
			flag,
			message,
		});
	};

	const handleAuth = () => {
		setIsAuth(false);
	};

	const handleTCPP = () => {
		setIsTCPP((prev) => !prev);
	};

	const handleTC = () => {
		setIsTC((prev) => !prev);
	};

	// Save current location
	const saveCurrentLocation = () => {
		// Check if the browser supports Geolocation API
		if (!navigator.geolocation) {
			console.error("Geolocation is not supported by your browser.");
			handleNotification(
				false,
				"Geolocation is not supported by your browser."
			);
			return;
		}

		// Get the user's current position
		navigator.geolocation.getCurrentPosition(
			(position) => {
				const { latitude, longitude } = position.coords;
				// Update the state with the location
				setUserLocation({ latitude, longitude });
			},
			(err) => {
				// Log errors to the console
				console.error("Error getting location:", err.message);
				handleNotification(false, err.message);
			},
			{
				enableHighAccuracy: true, // Request high accuracy if available
				timeout: 10000, // Timeout after 10 seconds
				maximumAge: 0, // Prevent cached locations
			}
		);
	};

	useEffect(() => {
		if (
			!userLocation?.latitude ||
			(!userLocation?.longitude &&
				!(deviceOS === "android" || deviceOS === "ios"))
		) {
			saveCurrentLocation();
		}
	}, [userLocation]);

	// Fetch user location
	const fetchUserAddress = async () => {
		const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${userLocation?.latitude}&lon=${userLocation?.longitude}`;

		try {
			const response = await fetch(url);
			const data = await response.json();
			if (data.display_name) {
				setUserLocationAddress(data.display_name);
			} else {
				setUserLocationAddress("Address not found");
			}
		} catch (error) {
			console.error("Error fetching address:", error);
			setUserLocationAddress("Error fetching address");
		}
	};

	useEffect(() => {
		if (userLocation?.latitude && userLocation?.longitude) {
			fetchUserAddress();
		}
	}, [userLocation?.latitude, userLocation?.longitude]);

	// Handle form submission for user registration
	const handleUserRegister = async () => {
		const url = `${baseUrl}/auth/register`;

		try {
			const response = await axios.post(url, userRegisterData);

			if (response?.data?.success) {
				// Save token and userId to cookies
				Cookies.set("token", response.data.token, { expires: 30 });
				Cookies.set("userId", response?.data.userId, { expires: 30 });
				getUser();
				setIsLoggedIn(true);
				setIsSidebar(false);

				// Clear the form data
				setUserRegisterData({
					name: "",
					email: "",
					contact: "",
					password: "",
					confirmPassword: "",
				});

				setIsAuth(false);
			} else {
				throw { response: { data: response.data } };
			}
		} catch (error) {
			throw error; // re-throw so caller catch block can handle
		}
	};

	// Handle form submission for user login
	const handleUserLogin = async () => {
		const url = `${baseUrl}/auth/login`;

		try {
			const response = await axios.post(url, userLoginData);

			//console.log("User response data : ", response?.data);
			if (response?.data?.success) {
				// Save token and userId to cookies
				Cookies.set("token", response.data.token, { expires: 30 });
				Cookies.set("userId", response?.data.userId, { expires: 30 });
				getUser();
				setIsLoggedIn(true);
				setIsSidebar(false);

				// Clear the form data
				setUserLoginData({
					email: "",
					password: "",
				});

				setIsAuth(false);
			}
		} catch (error) {
			console.error(
				"Error during registration:",
				error.response ? error.response.data : error.message
			);
		}
	};

	// Function to handle the forgot password request
	const handleForgotPassword = async () => {
		const url = `${baseUrl}/auth/forgot-password`;
		const email = userForgotPasswordData?.email;

		try {
			// Make POST request to the backend with email data
			const response = await axios.post(url, { email });

			// Log response data for debugging

			// Handle success
			if (response.data.success) {
				alert(response.data.message); // Display success message
			} else {
				handleNotification(false, response.data.message); // Display error message from backend
			}
		} catch (error) {
			// Handle error response
			console.error("Error during password reset request:", error);
			handleNotification(
				error.response.data.success,
				error.response.data.message
			);
		}
	};

	// Memoized function to get user profile data using useCallback
	const getUser = useCallback(async () => {
		try {
			const token = Cookies.get("token");
			const userId = Cookies.get("userId");
			const url = `${baseUrl}/auth/get-user`;

			// Make the GET request to fetch user data
			const response = await axios.get(url, {
				params: {
					userId: userId,
				},
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});

			if (response?.data?.success) {
				setUserData(response?.data?.user);
			}
		} catch (error) {
			console.error(
				"Error fetching user profile:",
				error.response ? error.response.data : error.message
			);
		}
	}, []);

	const deleteUser = async () => {
		const token = Cookies.get("token");
		const userId = Cookies.get("userId");
		const url = `${baseUrl}/auth/delete`;
		try {
			const response = await axios.delete(url, {
				params: {
					userId: userId,
				},
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});

			if (response?.data?.success) {
				handleUserLogout();
			}
		} catch (error) {
			console.error(
				"Error deleting user profile:",
				error.response ? error.response.data : error.message
			);
		}
	};

	useEffect(() => {
		const token = Cookies.get("token");
		const userId = Cookies.get("userId");
		setIsLoggedIn(!!(token && userId));

		if (token && userId) {
			getUser();
		}
	}, [navigate, getUser]);

	// To remove the cookies during logout
	const handleUserLogout = () => {
		Cookies.remove("token");
		Cookies.remove("userId");
		localStorage.removeItem("finelabsOrder");
		setIsLoggedIn(false);
		navigate("/");
	};

	{
		/*   useEffect(() => {
    saveCurrentLocation();
  }, []); */
	}

	useEffect(() => {
		detectDeviceOS();
	}, []);

	return (
		<AuthContext.Provider
			value={{
				setUserLocation,
				handleNotification,
				notificationData,
				handleAuth,
				isAuth,
				setIsAuth,
				isLoggedIn,
				userRegisterData,
				setUserRegisterData,
				handleUserRegister,
				userLoginData,
				setUserLoginData,
				handleUserLogin,
				handleUserLogout,
				isTCPP,
				handleTCPP,
				isTC,
				handleTC,
				userData,
				saveCurrentLocation,
				userLocation,
				isSearchVisible,
				setIsSearchVisible,
				scrollDirection,
				setScrollDirection,
				isSidebar,
				setIsSidebar,
				handleSidebarClick,
				userForgotPasswordData,
				setUserForgotPasswordData,
				handleForgotPassword,
				deviceOS,
				fetchUserAddress,
				userLocationAddress,
				deleteUser,
			}}>
			{children}
		</AuthContext.Provider>
	);
};

export const useAuthContext = () => useContext(AuthContext);

export default AuthProvider;
